/* Skapad av Claude Code — SVD FAQ (sections/svd-faq*.liquid).
   Vyer: start (Ämnen + Produkter som rader) → ämne/produkt (egen vy, #ankare) → sökresultat.
   Sök = ren JavaScript på sidans innehåll, ingen server. Regler (bygget, v4.5):
   * Ord matchar på ORDNIVÅ: "skopa" träffar "skopan", "pump" träffar "pumpen", aldrig inuti ord.
   * Stoppord (och, hur, är, jag …) ignoreras.
   * Varje sökord måste finnas i frågan (fråga + svar) ELLER vara delens namn/alternativa namn.
   * Bara namn ("magbalans") → hela delen överst. Namn + ord ("magbalans skopa") → bara
     frågorna i den delen som innehåller ordet. Bara ord ("pump") → frågor som innehåller ordet.
   Temaredigeraren: sektioner som laddas om (shopify:section:load) plockas upp igen, vald
   sektion/block öppnas direkt. */
(function () {
  'use strict';
  var STOP = { 'och': 1, 'eller': 1, 'hur': 1, 'var': 1, 'vad': 1, 'när': 1, 'vilken': 1, 'vilket': 1, 'jag': 1, 'min': 1, 'mitt': 1, 'mina': 1, 'den': 1, 'det': 1, 'de': 1, 'en': 1, 'ett': 1, 'är': 1, 'att': 1, 'för': 1, 'till': 1, 'på': 1, 'i': 1, 'av': 1, 'om': 1, 'med': 1, 'kan': 1, 'ska': 1, 'får': 1, 'har': 1, 'inte': 1, 'ni': 1, 'er': 1, 'vi': 1, 'så': 1, 'som': 1, 'man': 1, 'sig': 1, 'gör': 1, 'göra': 1 };
  function tokens(t) { return t.toLowerCase().replace(/[^a-zåäöéü0-9+]+/g, ' ').trim().split(/\s+/).filter(Boolean); }
  function qtokens(t) { var w = tokens(t).filter(function (x) { return !STOP[x]; }); return w.length ? w : tokens(t); }
  function tokHit(list, w) { for (var i = 0; i < list.length; i++) { var t = list[i]; if (t === w) return true; if (w.length >= 3 && t.indexOf(w) === 0) return true; if (t.length >= 4 && w.indexOf(t) === 0) return true; } return false; }
  function esc(s) { return String(s).replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; }); }

  function init() {
    var root = document.getElementById('svd-faq');
    if (!root || root.dataset.sfReady) return;
    root.dataset.sfReady = '1';
    var $ = function (s, c) { return (c || document).querySelector(s); };
    var $$ = function (s, c) { return [].slice.call((c || document).querySelectorAll(s)); };

    var input = $('#sf-q'), clear = $('#sf-q-clear'), wrap = $('#sf-search'), back = $('#sf-back');
    var home = $('#sf-home'), topic = $('#sf-topic'), topicBody = $('#sf-topic-body'), results = $('#sf-results');
    var resBody = $('#sf-res-body'), resN = $('#sf-res-n'), emptyBox = $('#sf-empty'), crumb = $('#sf-crumb');
    var topicsList = $('#sf-topics'), productsList = $('#sf-products'), nextList = $('#sf-next-list'), nextH = $('#sf-next-h');
    var views = [], byId = {}, current = 'home';
    var fbOn = root.dataset.fbEnabled !== 'false' && root.dataset.fbQuestion;

    // ---- gör mejladresser och webbadresser i svaren klickbara även när de skrivits som ren text i customizern
    var LINK_RE = /(\b[\w.+-]+@[\w-]+(?:\.[\w-]+)+\b)|((?:https?:\/\/)?(?:[a-z0-9-]+\.)+(?:se|com|net|org|nu|fi|no|dk|eu|io|app)\b(?:\/[^\s,;)]*)?)/gi;
    function autolink(root) {
      if (!root) return;
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), nodes = [], n;
      while ((n = walker.nextNode())) { if (!n.parentNode.closest('a') && LINK_RE.test(n.nodeValue)) nodes.push(n); LINK_RE.lastIndex = 0; }
      nodes.forEach(function (tn) {
        var frag = document.createDocumentFragment(), text = tn.nodeValue, last = 0, m;
        LINK_RE.lastIndex = 0;
        while ((m = LINK_RE.exec(text))) {
          var hit = m[0], end = m.index + hit.length;
          while (/[.,;:!?)]$/.test(hit)) { hit = hit.slice(0, -1); end--; }
          frag.appendChild(document.createTextNode(text.slice(last, m.index)));
          var a = document.createElement('a');
          if (m[1]) { a.href = 'mailto:' + hit; } else { a.href = /^https?:\/\//i.test(hit) ? hit : 'https://' + hit; a.target = '_blank'; a.rel = 'noopener'; }
          a.textContent = hit; frag.appendChild(a);
          last = end; LINK_RE.lastIndex = end;
        }
        frag.appendChild(document.createTextNode(text.slice(last)));
        tn.parentNode.replaceChild(frag, tn);
      });
    }
    function mark(el, q) {
      var t = el.dataset.q, sp = $('.sf-q__t', el);
      if (!q) { sp.textContent = t; return; }
      var re = new RegExp('(^|[^a-zåäö0-9])(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '[a-zåäö0-9]*)', 'i');
      var m = t.match(re); if (!m) { sp.textContent = t; return; }
      var i = m.index + m[1].length;
      sp.innerHTML = esc(t.slice(0, i)) + '<mark>' + esc(m[2]) + '</mark>' + esc(t.slice(i + m[2].length));
    }

    // ---- ta upp en vy (ämne/produkt) från dess sektion: startrad + index + flytt in i ämnesvyn
    function absorb(v) {
      var id = v.dataset.id;
      if (byId[id]) release(id);
      var tpl = $('template[data-sf-row]', v);
      if (tpl) {
        var li = tpl.content.firstElementChild.cloneNode(true);
        li.dataset.sfRowFor = id;
        (v.dataset.kind === 'product' ? productsList : topicsList).appendChild(li);
      }
      v._home = v.parentNode;
      v._name = tokens((v.dataset.title || '') + ' ' + (v.dataset.keywords || ''));
      $$('.sf-q', v).forEach(function (d) {
        autolink($('.sf-q__txt', d));
        d.dataset.q = $('.sf-q__t', d).textContent;
        d._tok = tokens(d.dataset.q + ' ' + $('.sf-q__txt', d).textContent);
        var fb = $('[data-sf-fb]', d);
        if (fb && fbOn) fb.innerHTML = '<span>' + esc(root.dataset.fbQuestion) + '</span><button type="button" data-fb="ja">Ja</button><button type="button" data-fb="nej">Nej</button>';
      });
      v.hidden = true;
      topicBody.appendChild(v);
      views.push(v); byId[id] = v;
    }
    function release(id) {
      var v = byId[id]; if (!v) return;
      views = views.filter(function (x) { return x !== v; }); delete byId[id];
      $$('[data-sf-row-for="' + id + '"]', root).forEach(function (li) { li.remove(); });
      if (v.parentNode === topicBody) v.remove();
    }
    $$('[data-sf-view]').forEach(absorb);

    // ---- feedback under svaren (ingen server; kan kopplas till analys senare)
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-fb]'); if (!b) return;
      var box = b.parentNode, yes = b.dataset.fb === 'ja';
      var txt = yes ? esc(root.dataset.fbThanks || 'Tack!') : esc(root.dataset.fbNo || 'Tack.');
      if (!yes && root.dataset.contactUrl) txt = txt.replace(/Mejla oss/i, '<a href="' + root.dataset.contactUrl + '">Mejla oss</a>');
      box.innerHTML = '<span class="sf-thanks">' + txt + '</span>';
    });

    // ---- iOS: stoppa autozoom när sökfältet får fokus (Safari zoomar in sidan och den blir
    //      bredare än skärmen → går att dra i sidled). maximum-scale=1 stänger av just
    //      fokus-zoomen; nypzoom fungerar ändå (iOS ignorerar värdet för pinch av tillgänglighetsskäl).
    var vp = document.querySelector('meta[name="viewport"]');
    if (vp && /iPhone|iPad|iPod/.test(navigator.userAgent)) {
      var c = vp.getAttribute('content') || 'width=device-width, initial-scale=1';
      vp.setAttribute('content', c.replace(/,\s*maximum-scale=[^,]*/i, '') + ', maximum-scale=1');
    }

    // ---- offset för den fasta raden under temats header.
    //      Temats .header-section är position:sticky top:0 och göms ALDRIG vid scroll, så rätt
    //      offset är headerns HÖJD – ett värde som inte ändras när man scrollar. Därför skrivs
    //      --sf-top bara vid load/resize, aldrig per scroll-frame.
    //      Tidigare följde JS:en headerns underkant på varje scroll-frame. Ovanför headern
    //      ligger announcement-raden (inte sticky), så underkanten kröp med varje scrollad pixel
    //      de första ~40 px – och eftersom värdet skrevs i requestAnimationFrame EFTER att
    //      browsern redan lagt om sin egen sticky header hamnade raden en frame efter. Det var
    //      studsen/hoppet vid riktningsbyte (uppmätt glapp: 29 px).
    //      Mät sticky-WRAPPERN (.header-section), inte theme-header: wrappern är elementet som
    //      pinnas på top:0, och theme-header kan rapportera en för låg höjd innan den responsiva
    //      navigationen har lagt om sig (uppmätt: 88 px i stället för 94 direkt efter en resize).
    var hdrSec = document.querySelector('.header-section');
    if (!hdrSec) { var el = document.querySelector('theme-header, .header'); while (el && el !== document.body) { var pos = getComputedStyle(el).position; if (pos === 'sticky' || pos === 'fixed') { hdrSec = el; break; } el = el.parentElement; } }
    function setTop() {
      var h = hdrSec && document.body.classList.contains('header-sticky--active') ? Math.round(hdrSec.getBoundingClientRect().height) : 0;
      root.style.setProperty('--sf-top', h + 'px');
    }
    function topOffset() { return parseInt(root.style.getPropertyValue('--sf-top'), 10) || 0; }
    setTop();
    // ResizeObserver fångar varje verklig höjdändring (responsiv nav, fonter, rotation) utan att
    // röra värdet vid scroll – headern byter aldrig höjd när man scrollar i det här temat.
    if (window.ResizeObserver && hdrSec) { new ResizeObserver(setTop).observe(hdrSec); }
    window.addEventListener('resize', setTop);
    window.addEventListener('orientationchange', setTop);
    window.addEventListener('load', setTop);

    // ---- vyer
    function show(view) {
      home.hidden = view !== 'home'; topic.hidden = view !== 'topic'; results.hidden = view !== 'results';
      back.hidden = view === 'home';
      current = view;
      var el = view === 'home' ? home : view === 'topic' ? topic : results;
      el.classList.remove('sf-view'); void el.offsetWidth; el.classList.add('sf-view');
    }
    function toTop() {
      var y = root.getBoundingClientRect().top + window.pageYOffset - topOffset();
      window.scrollTo({ top: Math.max(0, y), behavior: 'auto' });
    }
    function goHome(noScroll) {
      views.forEach(function (v) { v.hidden = true; });
      show('home');
      if (history.replaceState) history.replaceState(null, '', location.pathname + location.search);
      if (!noScroll) toTop();
    }
    function goTopic(id, noScroll) {
      var v = byId[id]; if (!v) return false;
      views.forEach(function (x) { x.hidden = x !== v; });
      $$('.sf-q', v).forEach(function (d) { d.open = false; mark(d, ''); });
      crumb.innerHTML = '<a href="#" data-sf-home>' + esc(root.dataset.crumb) + '</a><span>›</span>' + esc(v.dataset.title);
      var isProd = v.dataset.kind === 'product';
      nextH.textContent = isProd ? root.dataset.nextProducts : root.dataset.nextTopics;
      nextList.innerHTML = '';
      $$('li[data-sf-row-for]', isProd ? productsList : topicsList).forEach(function (li) { if (li.dataset.sfRowFor !== id) nextList.appendChild(li.cloneNode(true)); });
      show('topic');
      if (history.replaceState) history.replaceState(null, '', '#' + id);
      if (!noScroll) toTop();
      return true;
    }
    root.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-sf-go]');
      if (a) { e.preventDefault(); if (input.value) { input.value = ''; wrap.classList.remove('has-q'); } goTopic(a.getAttribute('href').slice(1)); return; }
      var hm = e.target.closest('[data-sf-home]');
      if (hm) { e.preventDefault(); goHome(); }
    });
    back.addEventListener('click', function () { if (current === 'results') { input.value = ''; wrap.classList.remove('has-q'); } goHome(); });
    $$('[data-sf-sugg]').forEach(function (b) { b.addEventListener('click', function () { input.value = b.textContent; run(); input.focus(); }); });

    // ---- sök
    function run() {
      var q = input.value.toLowerCase().replace(/\s+/g, ' ').trim();
      wrap.classList.toggle('has-q', !!q);
      if (q.length < 2) { if (current === 'results') goHome(true); return; }
      var words = qtokens(q), hits = 0, groups = [];
      views.forEach(function (v) {
        var nameWords = words.filter(function (w) { return tokHit(v._name, w); });
        var rest = words.filter(function (w) { return !tokHit(v._name, w); });
        var qs = $$('.sf-q', v), shown = [];
        if (rest.length) { qs.forEach(function (d) { if (rest.every(function (w) { return tokHit(d._tok, w); })) shown.push(d); }); }
        else if (nameWords.length) { shown = qs.slice(); }
        if (shown.length) groups.push({ v: v, qs: shown, name: nameWords.length > 0, rest: rest });
      });
      groups.sort(function (a, b) { return (b.name ? 1 : 0) - (a.name ? 1 : 0); });
      resBody.innerHTML = '';
      groups.forEach(function (g) {
        var grp = document.createElement('div'); grp.className = 'sf-res__grp';
        var lbl = g.v.dataset.kind === 'product' ? root.dataset.productLabel : root.dataset.topicLabel;
        grp.innerHTML = '<div class="sf-res__lbl"><em>' + esc(lbl) + ' · </em>' + esc(g.v.dataset.title) + '<a href="#' + g.v.dataset.id + '" data-sf-go>' + esc(root.dataset.showall) + ' ›</a></div><div class="sf-qlist"></div>';
        var ql = $('.sf-qlist', grp);
        g.qs.forEach(function (d) {
          var c = d.cloneNode(true); c.dataset.q = d.dataset.q; c.removeAttribute('data-shopify-editor-block');
          c.open = g.rest.length > 0 && g.qs.length <= 3; mark(c, g.rest.length ? g.rest[0] : '');
          ql.appendChild(c); hits++;
        });
        resBody.appendChild(grp);
      });
      resN.innerHTML = hits ? '<strong>' + hits + ' ' + esc(root.dataset.hitsLabel) + '</strong> "' + esc(input.value.trim()) + '"' : '';
      emptyBox.hidden = hits > 0;
      if (current !== 'results') { views.forEach(function (v) { v.hidden = true; }); show('results'); toTop(); }
    }
    input.addEventListener('input', run);
    clear.addEventListener('click', function () { input.value = ''; run(); input.focus(); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { input.value = ''; run(); } });

    // ---- start: #ankare öppnar direkt (djuplänk från produktsidor, mejl, mobilmeny)
    function fromHash(noScroll) { var id = decodeURIComponent((location.hash || '').slice(1)); if (id && byId[id]) goTopic(id, noScroll); else if (current !== 'home') goHome(true); else show('home'); }
    fromHash(true);
    window.addEventListener('hashchange', function () { fromHash(false); });

    // ---- temaredigeraren
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (e) {
        var v = e.target && e.target.querySelector ? e.target.querySelector('[data-sf-view]') : null;
        if (v) { absorb(v); goTopic(v.dataset.id, true); }
      });
      document.addEventListener('shopify:section:unload', function (e) {
        views.forEach(function (x) { if (x._home === e.target) release(x.dataset.id); });
        goHome(true);
      });
      document.addEventListener('shopify:section:select', function (e) {
        views.forEach(function (x) { if (x._home === e.target) goTopic(x.dataset.id, true); });
      });
      document.addEventListener('shopify:block:select', function (e) {
        var d = e.target && e.target.closest ? e.target.closest('.sf-q') : null;
        if (d) { var v = d.closest('[data-sf-view]'); if (v && v.hidden) goTopic(v.dataset.id, true); d.open = true; }
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
